module.exports = __webpack_public_path__ + "img/888-95370c.png";